import { clsx, type ClassValue } from 'clsx';

/** Class-name joiner (clsx). Note: it does not de-duplicate conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

export type { ClassValue };
